import { render, staticRenderFns } from "./HistoryShipping.vue?vue&type=template&id=6061c3e6&"
import script from "./HistoryShipping.vue?vue&type=script&lang=js&"
export * from "./HistoryShipping.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports